import { SxProps, Theme } from "@mui/material";

import { DATETIME_FORMATS } from "@/common/constants/common";

import EntityChangedByInfoCardBase, { Entity } from "./EntityChangedByInfoCardBase";

export interface EntityCreatedByInfoDisplayProps {
  entity: Entity | null | undefined;
  dateFormat?: string | null | undefined;
  sx?: SxProps<Theme>;
}

/** Shows who created the entity. */
export default function EntityCreatedByInfoCard({
  entity,
  dateFormat = DATETIME_FORMATS.DISPLAY_DATETIME,
  sx,
}: EntityCreatedByInfoDisplayProps) {
  return (
    <EntityChangedByInfoCardBase
      type='create'
      dateFormat={dateFormat}
      datetime={entity?.createdAt}
      userId={entity?.createdBy}
      sx={sx}
    />
  );
}
